import {
  CreateContextProvider,
  SaveButton,
  SimpleForm,
  Title,
  useCreateController,
} from "react-admin";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import { PageTopBreadcrumb } from "../../components/PageTopBreadcrumb";
import { UserRoleFormFields } from "./UserRoleFormFields";

export const UserRolesCreate = (props: any) => {
  const controller: any = useCreateController({
    resource: "user-roles/crud",
  });
  return (
    <CreateContextProvider value={controller}>
      <Title title="Regras de Usuário" />
      {/* toolbar={false}: Salvar no topo, na linha do breadcrumb */}
      <SimpleForm toolbar={false} defaultValues={{ permissions: [] }}>
        <PageTopBreadcrumb
          title="Regras de Usuário"
          firstPath="/#/user-roles/crud"
          secondTitle="Novo"
          actions={<SaveButton label="Salvar" />}
        />
        <Card sx={{ padding: 2, marginBottom: 3, width: "100%" }}>
          <CardHeader title="Criar Novo" />
          <CardContent>
            <UserRoleFormFields />
          </CardContent>
        </Card>
      </SimpleForm>
    </CreateContextProvider>
  );
};
